/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function BrowserResize(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'BrowserResize',
      'aria-hidden': true,
      focusable: false,
      width:  52 * scale,
      height: 40 * scale,
      viewBox: '0 0 52 40',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M26 32v-2h-4.586l6.293-6.293L32 19.414V24h2v-8h-8v2h4.586l-4.293 4.293L20 28.586V24h-2v8zM2 8h48V2H2zm0 30h48V10H2zM52 0v40H0V0zM11 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0","fill":"currentColor"}))
}
